const timeoutActions = {};
export const InitializeCustomWorker = (successEvent, errorEvent) => {
  const worker = new Worker(new URL("/Worker.js", import.meta.url), {
    type: "module",
    credentials: "same-origin",
  });
  worker.onmessage = (results) => {
    worker.terminate();
    if (successEvent) {
      successEvent(results.data);
    }
  };
  worker.onerror = (results) => {
    worker.terminate();
    if (errorEvent) {
      errorEvent(results);
    }
  };
  worker.onmessageerror = (results) => {
    worker.terminate();
    if (errorEvent) {
      errorEvent(results);
    }
  };
  return {
    worker,
    setTimeOut: (action, seconds) => {
      if (timeoutActions[action]) {
        timeoutActions[action].terminate();
        delete timeoutActions[action];
      }
      timeoutActions[action] = worker;
      return {
        action,
        seconds,
        responseType: -3,
      };
    },
    payload: (action, requestOptions, responseType = 0) => {
      return {
        action,
        requestOptions,
        responseType,
      };
    },
  };
};
